import React, {Component} from 'react';
import users from './store/user'
import {Link, browserHistory} from 'react-router'
import {onLoginForHeader, logout} from './firebase'
import ToggleDisplay from 'react-toggle-display';
import * as firebase from "firebase";

import './css/header.css';

const showMenu =(e)=> {
    e.preventDefault();
    let layer = document.getElementById('modal-overlay');
    let open = document.getElementById('menu-icon-open');
    let close = document.getElementById('menu-icon-close');
    layer.classList.toggle('show');
    open.classList.toggle('show');
    close.classList.toggle('show');
}

// Logout
function whenLoginGotoUserPage(){
  logout()
  users.setInit();
  browserHistory.push("/");
}

export default class Top extends Component {

  constructor(props) {
    super(props);
    this.state = {
      photoURL: "",
      isLogin:false,
      uid:'',
      trustdockResult:'waiting',
      trustdockId:'',
      trustdockToken:''

    }
    this.loginCheck()
    this.checkNewFlow(props)
  }

  //登録フローチェック
  checkNewFlow = (props) => {
    if(!props.parentProps) return
    let pathname = props.parentProps.location.pathname;

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase.database().ref('users/' + user.uid).once('value').then((snapshot) => {
          if(!snapshot.val()) {
            browserHistory.push('/newflow1')
            return
          }
          this.checkNewFlowPage(snapshot.val(),pathname)
        })
      } else {
        // ログインユーザーがいない
        browserHistory.push('/newflow1')
        return       
      }
    })
  }
  checkNewFlowPage = (userdata,pathname) => {
    //console.log(pathname)
    switch(pathname) {
      case '/email_register':
        if(userdata.hasOwnProperty('email')) {
          browserHistory.push('/newflow3')
        }
        break        
      case '/newflow3':
        //console.log(userdata.uid)
        if(!userdata.hasOwnProperty('uid')) {
          browserHistory.push('/newflow1')
        } else if(!userdata.hasOwnProperty('email')) {
          browserHistory.push('/email_register')
        }
        break
      case '/newflow5':
        if(!userdata.hasOwnProperty('uid') || !userdata.hasOwnProperty('phoneNumber')) {
          browserHistory.push('/newflow3')
        } else if(!userdata.hasOwnProperty('email')) {
          browserHistory.push('/email_register')
        }
        break  
      case '/newflow6':
        if(!userdata.hasOwnProperty('uid') || !userdata.hasOwnProperty('phoneNumber')) {
          browserHistory.push('/newflow3')
        } else if(!userdata.hasOwnProperty('email')) {
          browserHistory.push('/email_register')
        }
        break                         
      case '/newflow8':
        if(!userdata.hasOwnProperty('uid') || !userdata.hasOwnProperty('phoneNumber')) {
          browserHistory.push('/newflow3')
        } else if(!userdata.hasOwnProperty('email')) {
          browserHistory.push('/email_register')
        }
        break  
      case '/newflow10':
        if(!userdata.hasOwnProperty('uid') || !userdata.hasOwnProperty('phoneNumber') || !userdata.hasOwnProperty('termsCheck')) {
          browserHistory.push('/newflow8')
        } else if(!userdata.hasOwnProperty('email')) {
          browserHistory.push('/email_register')
        }
        break          
      default:
        break
    }

  }


  //componentDidMount() {
    //var scope = this
  //callbackにmount後でなければならない処理がないのでconstructorでloginチェックとユーザーデータを取得する    
  loginCheck = () => {
    // ログインチェック
    onLoginForHeader((isLogin) => {
      if (true === isLogin) {
        this.setState({photoURL: users.getMyUser().photoURL, isLogin:isLogin})
        this.setState({
          uid:users.getMyUser().uid,
          trustdockResult:users.getMyUser().trustdockResult,
          trustdockId:users.getMyUser().trustdockId,
          trustdockToken:users.getMyUser().trustdockToken,
        })
      }
    }, false);
  }

  substituteLink = (e) => {
    if(/newflow10/.test(window.location)) {
      e.preventDefault()
      window.location.href = e.currentTarget.dataset.href
    }
  }

  passwordChange = () => {
    if (undefined === users.getMyUser() || !users.getMyUser().facebookId) {
      return (
        <div className="menu-list">
          <Link to="/passwordChange" >パスワード設定</Link>
        </div>
      )
    } else {
      return null;
    }
  }

  initialImage = () => {
    const user = users.getMyUser();
    if (user.facebookId) {
      return 'https://graph.facebook.com/' + users.getMyUser().facebookId + '/picture?width=100&height=100';
    } else {
      return '/img/common/m-profile-img@2x.png'
    }
  }

  render() {
    const {
      uid,
      trustdockResult,
      trustdockId,
      trustdockToken
    } = this.state

    let noTrustDock = !trustdockResult && !trustdockId && !trustdockToken ? ' no-td-certification' : ''

    return(
        <div className="header">
          <Link to="/" className="top-link"><img alt="" className="header-title" src="/img/lp/logo_white.png" /></Link>
          <ToggleDisplay if={!this.props.isOauth}>
            <div id="menu-icon-open" className={this.state.isLogin ? `header-icon show${noTrustDock}` : "header-icon show"}>
              <img alt="" className={this.state.isLogin ? "header-profile" : ""} onClick={showMenu} src={this.state.isLogin ? users.getMyUser().updatePhoto ? users.getMyUser().updatePhoto : this.initialImage() : "/img/lp/icon_menu.png"} />
            </div>
            <div id="menu-icon-close" className="header-icon" onClick={showMenu} ></div>
          </ToggleDisplay>
          <ToggleDisplay if={!this.state.isLogin}>
            <div id="modal-overlay" onClick={showMenu}>
              <div className="menu-list">
                <Link to="/lpLogin" >ログイン</Link>
              </div>
              <div className="menu-list">
                <Link to="/newflow1">アカウント登録〈無料〉</Link>
              </div>
              <div className="menu-list">
                <Link to="/">MyRateとは？</Link>
              </div>
            </div>
          </ToggleDisplay>

          <ToggleDisplay if={this.state.isLogin}>
            <div id="modal-overlay" onClick={showMenu}>
              <div className="menu-list">
                <Link to={`/user/${uid}`} data-href={`/user/${uid}`} onClick={this.substituteLink}>ライセンスを見る</Link>
              </div>
              {/* MyRate保険は2019年3月末のリリースに含めない */}
              {/* <div className="menu-list">
                <Link to="/insurance">MyRate保険の履歴</Link>
              </div> */}
              <div className={`menu-list${noTrustDock}`}>
                <Link to="/newEdit" >アカウント編集</Link>
              </div>
              {this.passwordChange()}
              <div className="menu-list">
                <Link onClick={whenLoginGotoUserPage} >ログアウト</Link>
              </div>
            </div>
          </ToggleDisplay>
        </div>


    )
  }
}



// WEBPACK FOOTER //
// ./src/header.js